/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-25 20:55:00
 * @Instruduction: 状态入口
 */

import Vue from 'vue'
import Vuex from 'vuex'
import { IUserState } from './modules/user'
import { IPermissionState } from './modules/permission'

Vue.use(Vuex)

export interface IRootState {
    user: IUserState
    permission: IPermissionState
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({})
